import httpClient from '@/api/http-client'

const urlPrefix = '/bpm/v1/kanban'

export default {

  /**
   * Получение настроек доступа к доске.
   *
   * @param boardId
   * @returns {*}
   */
  getAccess( boardId ) {

    return httpClient.http
      .get( `${urlPrefix}/boards/${boardId}/accesses` )
      .then( response => {
        return response.data
      } )
  },

  /**
   * Установка настроек доступа к доске.
   *
   * @param boardId
   * @param scopes
   * @returns {Promise<T>}
   */
  setAccess( boardId, scopes ) {

    const request = {
      scopes: scopes
    }

    return httpClient.http
      .patch( `${urlPrefix}/boards/${boardId}/accesses`, request )
      .then( response => {
        return response.data
      } )
  }
}



// WEBPACK FOOTER //
// ./src/apps/bpm/kanban/api/access/api.js